import { render, staticRenderFns } from "./BirimIyılestirmeleri.vue?vue&type=template&id=53530a34"
import script from "./BirimIyılestirmeleri.vue?vue&type=script&lang=js"
export * from "./BirimIyılestirmeleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports